(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dogchain-spotlight"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const initialize=(root)=>{
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      const form=root.querySelector('.dcs-form');
      const quantity=form?.querySelector('[name="quantity"]');
      root.querySelectorAll('[data-quantity-change]').forEach(button=>button.addEventListener('click',()=>{quantity.value=Math.min(99,Math.max(1,(Number(quantity.value)||1)+Number(button.dataset.quantityChange)));}));
      const purchase=root.querySelector('.dcs-purchase');
      const sticky=root.querySelector('[data-sticky-buy]');
      if(purchase&&sticky&&'IntersectionObserver'in window){new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0}).observe(purchase);}
    };
    document.querySelectorAll('[data-spotlight]').forEach(initialize);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-spotlight]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
